import { cdcAuthPlugin } from '@/plugins/cdc/auth/cdc-auth.js';
import { cdcConsentPlugin } from '@/plugins/cdc/cdc-consent.js';
import { cdcProfilePlugin } from '@/plugins/cdc/cdc-profile.js';
import { cdcRegistrationPlugin } from '@/plugins/cdc/cdc-registration.js';

/**
 * This plugin handles the cdc identity functionalities.
 */
export default {
  install(app) {
    app.config.globalProperties.$cdc = {
      auth: cdcAuthPlugin,
      consent: cdcConsentPlugin,
      profile: cdcProfilePlugin,
      registration: cdcRegistrationPlugin,
    };
  },
};
